<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-light-primary elevation-2">
    <!-- Brand Logo -->
    <Logo />
    <!-- Sidebar -->
    <div class="sidebar">
      <AdminNav />
    </div>
  </aside> 
  <div class="content-wrapper">
    <!-- List / -->
    <router-view></router-view>
  </div>
  
  <footer class="main-footer">
    © <strong>More News</strong>

  </footer>
    
    
</template>
<script>
import { defineComponent } from 'vue';
import AdminNav from '@/components/AdminNav.vue';
import Logo from '@/components/logo/components/Logo.vue';

export default defineComponent({
    name: "AdminLayout",
    components: {
      AdminNav
    }
});
</script>
